document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.getElementById("birthday");
  const calendar = document.getElementById("calendar");
  const monthYear = document.getElementById("month-year");
  const prevMonth = document.getElementById("prev-month");
  const nextMonth = document.getElementById("next-month");

  const daysOfWeek = ["Må", "Ti", "On", "To", "Fr", "Lö", "Sö"]; // Start from Monday
  const months = [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ];

  let currentDate = new Date();
  let currentMonth = currentDate.getMonth();
  let currentYear = currentDate.getFullYear();

  function renderCalendar(month, year) {
    calendar.innerHTML = "";

    // Set the month and year display
    monthYear.textContent = `${months[month]} ${year}`;

    // Add day labels (starting from Monday)
    daysOfWeek.forEach((day) => {
      const dayDiv = document.createElement("div");
      dayDiv.textContent = day;
      dayDiv.style.fontWeight = "bold";
      dayDiv.classList.add("weekday-title");
      calendar.appendChild(dayDiv);
    });

    // Get the first day of the month (adjusting for Monday as the start of the week)
    let firstDay = new Date(year, month, 1).getDay();
    firstDay = firstDay === 0 ? 6 : firstDay - 1; // Adjust Sunday (0) to be last in our Monday-starting week

    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const prevMonthDays = new Date(year, month, 0).getDate();

    // Add previous month days
    for (let i = firstDay; i > 0; i--) {
      const prevDayCell = document.createElement("div");
      prevDayCell.textContent = prevMonthDays - i + 1;
      prevDayCell.classList.add("disabled", "previous-date");
      calendar.appendChild(prevDayCell);
    }

    // Add current month days
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dayCell = document.createElement("div");
      dayCell.textContent = day;

      if (date < currentDate.setHours(0, 0, 0, 0)) {
        dayCell.classList.add("disabled", "previous-date");
      } else if (
        currentDate.getDate() === day &&
        currentDate.getMonth() === month &&
        currentDate.getFullYear() === year
      ) {
        dayCell.classList.add("current-date", "selected");
        dateInput.value = `${year}-${String(month + 1).padStart(
          2,
          "0"
        )}-${String(day).padStart(2, "0")}`;
        scrollToCenter(dayCell);
      } else {
        dayCell.classList.add("future-date");
        dayCell.addEventListener("click", function () {
          document
            .querySelectorAll("#calendar div.selected")
            .forEach((el) => el.classList.remove("selected"));
          dayCell.classList.add("selected");

          const formattedDate = `${year}-${String(month + 1).padStart(
            2,
            "0"
          )}-${String(day).padStart(2, "0")}`;
          dateInput.value = formattedDate;

          scrollToCenter(dayCell);
        });
      }

      calendar.appendChild(dayCell);
    }

    // Add next month days to complete the grid
    const totalCells = firstDay + daysInMonth;
    const nextMonthDays = 7 - (totalCells % 7 === 0 ? 7 : totalCells % 7);
    for (let i = 1; i <= nextMonthDays; i++) {
      const nextDayCell = document.createElement("div");
      nextDayCell.textContent = i;
      nextDayCell.classList.add("disabled", "future-date");
      calendar.appendChild(nextDayCell);
    }
  }

  function scrollToCenter(element) {
    const container = document.getElementById("custom-date-picker");
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const offset =
      elementRect.top -
      containerRect.top +
      elementRect.height / 2 -
      containerRect.height / 2;

    container.scrollBy({ top: offset, behavior: "smooth" });
  }

  prevMonth.addEventListener("click", function () {
    currentMonth--;
    if (currentMonth < 0) {
      currentMonth = 11;
      currentYear--;
    }
    renderCalendar(currentMonth, currentYear);
  });

  nextMonth.addEventListener("click", function () {
    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
    renderCalendar(currentMonth, currentYear);
  });

  renderCalendar(currentMonth, currentYear);
});

document.addEventListener("DOMContentLoaded", function () {
  const radio1 = document.getElementById("radio-1");

  const radio2 = document.getElementById("radio-2");
  const inputWrapper = document.getElementById("input-wrapper");
  const dynamicInput = document.getElementById("dynamic-input");

  // Toggle input field visibility based on radio selection
  radio1.addEventListener("change", function () {
    if (radio1.checked) {
      inputWrapper.style.display = "none";
    }
  });

  radio2.addEventListener("change", function () {
    if (radio2.checked) {
      inputWrapper.style.display = "block";
    }
  });

  // Assign the input value to the radio button value dynamically
  dynamicInput.addEventListener("input", function () {
    radio2.value = dynamicInput.value || "Annat sätt"; // Default value if input is empty
  });
});
